export const Widths = {
  CustomerContact: "160px",
  TuringContact: "160px",
  CustomerContactLarge: "190px",
  TuringContactLarge: "180px",
  CustomerContactExtraLarge: "210px",
  TuringContactExtraLarge: "210px",
};
